import {
  TeacherClassStudentsDocument,
  TeacherClassStudentsQuery,
  TeacherClassStudentsQueryVariables,
  TeacherGetMyLiveClassesDocument,
  TeacherGetMyLiveClassesQuery,
  TeacherGetMyLiveClassesQueryVariables,
  TeacherInsertStudentsForLiveClassDocument,
  TeacherInsertStudentsForLiveClassMutation,
  TeacherInsertStudentsForLiveClassMutationVariables,
} from "../types";
import { client } from "../../client";

export async function liveClassGetStudents(
  class_id: string
): Promise<TeacherClassStudentsQuery> {
  const response = await client.query<
    TeacherClassStudentsQuery,
    TeacherClassStudentsQueryVariables
  >({
    query: TeacherClassStudentsDocument,
    variables: {
      class_id,
    },
    fetchPolicy: "network-only",
  });
  return response.data;
}

export async function insertAttendees(
  variables: TeacherInsertStudentsForLiveClassMutationVariables
): Promise<TeacherInsertStudentsForLiveClassMutation> {
  try {
    const response = await client.mutate<
      TeacherInsertStudentsForLiveClassMutation,
      TeacherInsertStudentsForLiveClassMutationVariables
    >({
      mutation: TeacherInsertStudentsForLiveClassDocument,
      variables,
    });

    return response.data;
  } catch (e) {
    throw e;
  }
}

export async function getMyLiveClasses(
  variables: TeacherGetMyLiveClassesQueryVariables
): Promise<TeacherGetMyLiveClassesQuery> {
  try {
    const response = await client.query<
      TeacherGetMyLiveClassesQuery,
      TeacherGetMyLiveClassesQueryVariables
    >({
      query: TeacherGetMyLiveClassesDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return response.data;
  } catch (e) {
    throw e;
  }
}
